import request from "@/plugins/axiosRequest";

const bitcoinUrl = "/api/dashboard/v1/payout_bitcoin";
const ethereumUrl = "/api/dashboard/v1/payout_ethereum";
const cardanoUrl = "/api/dashboard/v1/payout_cardano";
const rippleUrl = "/api/dashboard/v1/payout_ripple";
const stellarUrl = "/api/dashboard/v1/payout_stellar";

function getUrl(type) {
  let url;
  switch (type) {
    case "BTC":
      url = bitcoinUrl;
      break;
    case "ETH":
      url = ethereumUrl;
      break;
    case "ADA":
      url = cardanoUrl;
      break;
    case "XLM":
      url = stellarUrl;
      break;
    case "XRP":
      url = rippleUrl;
      break;
    default:
      url = bitcoinUrl;
  }
  return url;
}

export function fetchListPayoutWallet(query, type) {
  let url = getUrl(type);
  return request({
    url: url,
    method: "get",
    params: query
  });
}

export function fetchPayoutWallet(id, type) {
  let url = getUrl(type);
  return request({
    url: url,
    method: "get",
    params: { id }
  });
}

export function postNewPayoutWallet(data, type) {
  let url = getUrl(type);
  return request({
    url: url,
    method: "post",
    data
  });
}

export function deletePayoutWallet(id, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${id}`,
    method: "delete"
  });
}

export function updatePayoutWallet(data, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${data.id}`,
    method: "PUT",
    data
  });
}

export function resendConfirmationPayout(id, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${id}/resend-confirmation-token`,
    method: "POST"
  });
}
